import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";

export type DialogAction = {
  label: string;
  onClick: () => void;
  type?: "default" | "primary" | "secondary";
};

type ActionDialogProps = {
  open: boolean;
  title: string;
  message: string;
  actions: DialogAction[];
  onClose: () => void;
};

const ActionDialog: React.FC<ActionDialogProps> = ({
  open,
  title,
  message,
  actions,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        {actions.map((action, idx) => (
          <Button
            key={idx}
            onClick={action.onClick}
            variant="contained"
          >
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default ActionDialog;
